/**
 * Общие примитивы live-мапперов отчётов: терпимые касты и тыйын → сом.
 */

export type Raw = Record<string, unknown>;

export const asObj = (v: unknown): Raw => (typeof v === 'object' && v !== null ? (v as Raw) : {});
export const asNum = (v: unknown): number => (typeof v === 'number' && Number.isFinite(v) ? v : 0);
export const asStr = (v: unknown): string => (typeof v === 'string' ? v : '');
export const arr = (v: unknown): unknown[] => (Array.isArray(v) ? v : []);
export const toSom = (tiyin: unknown): number => Math.round(asNum(tiyin) / 100);
